//数据库
const state = {
  selectaddress:"",//选择地址
  coupon:"",//优惠券
  areaCoupon: "",// 专场折扣
  payment:"",//在待付款详情页面操作后用于刷新我的订单页面的标识  有就是需要刷新
  userInfo:{},
  directorText:'',
  agentText:'',
  receive:''
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js